<template>
	<div ref="steps" class="pro_step">
		<!-- 第一步 -->
		<div class="step clear_both">
			<span class="num bg_theme">1</span>
			<div class="install_l">
				<h1 class="step_title">安装浏览器<i class="speed_logo"></i><i class="chrome_logo"></i></h1>
				<p class="detail">推荐安装360极速浏览器：<a class="text_theme text_underline" href="https://browser.360.cn/ee/" target="_blank">点击下载</a></p>
				<p class="detail">推荐安装谷歌浏览器：<a class="text_theme text_underline" href="https://www.google.cn/chrome/" target="_blank">点击下载</a></p>
			</div>
			<div class="install_r">
				<h3 class="title">视知觉学习治疗软件专业版</h3>
				<div class="ways">
					<a class="way" href="javascript: void(0);" style="margin-right: 30px;" @click="linkToPro"><i class="pc_icon"></i>网页版</a>
					<a class="way" href="http://download.uflycloud.com/%E7%A7%91%E9%A3%9E%E8%A7%86%E7%9F%A5%E8%A7%89%E4%B8%93%E4%B8%9A%E7%89%882.0%E5%AE%89%E8%A3%85%E5%8C%85win32.exe"><i class="download_icon"></i>电脑客户端</a>
				</div>
			</div>
		</div>
		<!-- 第一步 end -->
		
		<!-- 第二步 -->
		<div class="step">
			<span class="num bg_theme">2</span>
			<h1 class="step_name">登录及训练注意事项</h1>
			<div class="video_box">
				<video v-if="isLogin" ref="note_video" controls poster="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E7%99%BB%E5%BD%95%E5%8F%8A%E6%B3%A8%E6%84%8F.jpg">
					<source src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E7%99%BB%E5%BD%95%E5%8F%8A%E8%AE%AD%E7%BB%83%E5%87%86%E5%A4%87%E6%B3%A8%E6%84%8F%E4%BA%8B%E9%A1%B9%EF%BC%88%E4%B8%93%E4%B8%9A%E7%89%88%EF%BC%89.mp4" type="video/mp4">
					你的浏览器不支持video标签！！！
				</video>
				<img v-if="!isLogin" src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E7%99%BB%E5%BD%95%E5%8F%8A%E6%B3%A8%E6%84%8F.jpg" alt="">
				<div v-show="!noteVideo_play" class="mask" @click="handleNoteVideoPlay"><i></i></div>
			</div>
		</div>
		<!-- 第二步 end -->
		
		<!-- 第三步 -->
		<div class="step">
			<span class="num bg_theme">3</span>
			<h1 class="step_name">通过主界面，可知悉所处康复阶段</h1>
			<div class="video_box">
				<video v-if="isLogin" ref="recovery_video" controls poster="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/kangfujieduan.png">
					<source src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/kangfujieduan.mp4" type="video/mp4">
					你的浏览器不支持video标签！！！
				</video>
				<img v-if="!isLogin" src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/kangfujieduan.png" alt="">
				<div v-show="!recoveryVideo_play" class="mask" @click="handleRecoveryVideoPlay"><i></i></div>
			</div>
		</div>
		<!-- 第三步 end -->
		
		<!-- 第四步 -->
		<div class="step">
			<span class="num bg_theme">4</span>
			<h1 class="step_name">查看训练演示</h1>
			<div class="video_group" style="margin-top: 10px;">
				<h3 class="title"><i class="bg_theme"></i>视知觉训练</h3>
				<div class="clear_both">
					<div class="video_item">
						<div class="video_wrap">
							<img src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/jiezhipinlv.png" alt="" style="display: block;width: 100%;height: 100%;">
							<div class="mask" @click="handleItemClick(0)"><i></i></div>
						</div>
						<p class="video_name text_one">截止频率训练</p>
					</div>
					<div class="video_item">
						<div class="video_wrap">
							<img src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/guangshannnegli.png" alt="" style="display: block;width: 100%;height: 100%;">
							<div class="mask" @click="handleItemClick(1)"><i></i></div>
						</div>
						<p class="video_name text_one">光栅能力训练</p>
					</div>
					<div class="video_item">
						<div class="video_wrap">
							<img src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/youbiaonengli.png" alt="" style="display: block;width: 100%;height: 100%;">
							<div class="mask" @click="handleItemClick(2)"><i></i></div>
						</div>
						<p class="video_name text_one">游标能力训练</p>
					</div>
				</div>
				<div class="clear_both">
					<div class="video_item">
						<div class="video_wrap">
							<img src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/tuxianglunkuo.png" alt="" style="display: block;width: 100%;height: 100%;">
							<div class="mask" @click="handleItemClick(3)"><i></i></div>
						</div>
						<p class="video_name text_one">图像轮廓训练</p>
					</div>
					<div class="video_item">
						<div class="video_wrap">
							<img src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/wenlinengli.png" alt="" style="display: block;width: 100%;height: 100%;">
							<div class="mask" @click="handleItemClick(4)"><i></i></div>
						</div>
						<p class="video_name text_one">纹理能力训练</p>
					</div>
					<div class="video_item">
						<div class="video_wrap">
							<img src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/dongwurenzhi.png" alt="" style="display: block;width: 100%;height: 100%;">
							<div class="mask" @click="handleItemClick(5)"><i></i></div>
						</div>
						<p class="video_name text_one">动物视认知训练</p>
					</div>
				</div>
			</div>
			
			<div class="video_group" style="margin-top: 30px;">
				<h3 class="title"><i class="bg_theme"></i>双眼视训练</h3>
				<div class="clear_both">
					<div class="video_item">
						<div class="video_wrap">
							<img src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/tongshishi.png" alt="" style="display: block;width: 100%;height: 100%;">
							<div class="mask" @click="handleItemClick(6)"><i></i></div>
						</div>
						<p class="video_name text_one">同时视训练</p>
					</div>
					<div class="video_item">
						<div class="video_wrap">
							<img src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/rongheshi.png" alt="" style="display: block;width: 100%;height: 100%;">
							<div class="mask" @click="handleItemClick(7)"><i></i></div>
						</div>
						<p class="video_name text_one">融合视训练</p>
					</div>
					<div class="video_item">
						<div class="video_wrap">
							<img src="https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/litishi.png" alt="" style="display: block;width: 100%;height: 100%;">
							<div class="mask" @click="handleItemClick(8)"><i></i></div>
						</div>
						<p class="video_name text_one">立体视训练</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 第四步 end -->
		
		<!-- 第五步 -->
		<div class="step">
			<span class="num bg_theme">5</span>
			<h1 class="step_name">扫码关注小程序，得训练报告</h1>
			<div class="clear_both" style="margin-top: 20px;">
				<div class="reveal_l">
					<img src="../../../../assets/guide_phone.png" alt="">
				</div>
				<div class="reveal_r">
					<img class="cui" src="../../../../assets/guide_sheet.png" alt="">
					<div class="code_desc">关注康视医从小程序，科飞每日会发送一份训练报告哦！</div>
				</div>
			</div>
		</div>
		<!-- 第五步 end -->
	</div>
</template>

<script>
	import Login from '../../../../utils/login.js';
	import { mapState } from 'vuex';
	
	export default {
		props: {
			scrollTop: {
				type: Number,
				default: 0
			}
		},
		mounted() {
			this.noteVideo_offsetTop = 0;
			this.recoveryVideo_offsetTop = 0;
			this.demo_src = [
				'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/Task1.mp4',	// 截止频率训练演示
				'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/Task4.mp4',	// 光栅能力训练演示
				'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/Task6.mp4',	// 游标能力训练演示
				'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/Task8.mp4',	// 图像轮廓训练演示
				'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/Task11.mp4',	// 纹理能力训练演示
				'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/%E5%8A%A8%E7%89%A9%E8%AE%A4%E7%9F%A5%E8%AE%AD%E7%BB%83%E6%BC%94%E7%A4%BA.mp4',	// 动物视认知训练演示
				'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/Task302.mp4',	// 同时视能力训练演示
				'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/Task301.mp4',	// 融合视能力训练演示
				'https://ufly-kangshi-cloud-img-lib.oss-cn-hangzhou.aliyuncs.com/ufly-official-website/Task303.mp4'	// 立体式能力训练演示
			];
			this.isLogin = Login.checkLogin();
			this.getStepOffset();
			if (this.isLogin) {
				this.$nextTick(() => {
					this.initVideoOffsetTop();
					this.addVideoEvents();
				});
			}
		},
		beforeDestroy() {
			this.isLogin && this.removeVideoEvents();
		},
		data() {
			return {
				isLogin: false,
				noteVideo_play: false,
				recoveryVideo_play: false
			}
		},
		computed: {
			...mapState([
				'safeInfo'
			])
		},
		methods: {
			/*************** @Events *******************/
			// 登录及训练注意事项视频播放
			handleNoteVideoPlay() {
				if (this.isLogin) {
					this.$refs.note_video.play();
					this.noteVideo_play = true;
				} else {
					this.$router.push({path: '/index/login'});
				}
			},
			// 康复阶段视频播放
			handleRecoveryVideoPlay() {
				if (this.isLogin) {
					this.$refs.recovery_video.play();
					this.recoveryVideo_play = true;
				} else {
					this.$router.push({path: '/index/login'});
				}
			},
			// 每一个小视频播放
			handleItemClick(index) {
				this.$emit('onVideoClick', this.demo_src[index]);
			},
			// 打开专业版网页
			linkToPro() {
				let link = '';
				this.safeInfo.kt
				? (link = `http://training.uflyvision.com.cn/eaglepro/?kt=${ this.safeInfo.kt }`)
				: (link = `http://training.uflyvision.com.cn/eaglepro/`);
				window.open(link);
			},
			
			/*************** @Function *******************/
			// 获取每一步距离顶部的距离
			getStepOffset() {
				let steps = this.$refs.steps.children;
				let offsets = [];
				for (let i = 0;i < steps.length;i++) {
					i == 0 ? offsets.push(this.$refs.steps.offsetTop - 80) : offsets.push(steps[i].offsetTop + this.$refs.steps.offsetTop - 80);
				}
				offsets.push(this.$refs.steps.offsetTop + this.$refs.steps.offsetHeight - 80);
				this.$emit('emitOffsets', offsets);
			},
			// 初始化video距离顶部
			initVideoOffsetTop() {
				let noteVideo_offsetTop = this.$refs.note_video.parentElement.offsetTop + this.$refs.note_video.parentElement.parentElement.offsetTop + this.$refs.note_video.parentElement.parentElement.parentElement.offsetTop + this.$refs.note_video.offsetHeight - 80;
				let recoveryVideo_offsetTop = this.$refs.recovery_video.parentElement.offsetTop + this.$refs.recovery_video.parentElement.parentElement.offsetTop + this.$refs.recovery_video.parentElement.parentElement.parentElement.offsetTop + this.$refs.recovery_video.offsetHeight - 80;
				this.noteVideo_offsetTop = noteVideo_offsetTop;
				this.recoveryVideo_offsetTop = recoveryVideo_offsetTop;
			},
			// 给video添加事件
			addVideoEvents() {
				this.$refs.note_video.addEventListener('play', this.noteVideoPlay, false);
				this.$refs.note_video.addEventListener('ended', this.noteVideoEnd, false);
				this.$refs.recovery_video.addEventListener('play', this.recoveryVideoPlay, false);
				this.$refs.recovery_video.addEventListener('ended', this.recoveryVideoEnd, false);
			},
			// 移除video事件
			removeVideoEvents() {
				this.$refs.note_video.removeEventListener('play', this.noteVideoPlay);
				this.$refs.note_video.removeEventListener('ended', this.noteVideoEnd);
				this.$refs.recovery_video.removeEventListener('play', this.recoveryVideoPlay);
				this.$refs.recovery_video.removeEventListener('ended', this.recoveryVideoEnd);
			},
			// 登录及注意事项视频播放
			noteVideoPlay() {
				this.recoveryVideo_play && this.$refs.recovery_video.pause();
			},
			// 登录及注意事项视频播放完毕
			noteVideoEnd() {
				this.noteVideo_play = false;
			},
			// 康复视频播放
			recoveryVideoPlay() {
				this.noteVideo_play && this.$refs.note_video.pause();
			},
			// 康复视频播放完毕
			recoveryVideoEnd() {
				this.recoveryVideo_play = false;
			},
			// 当全屏视频出现时暂停视频播放
			pauseVideo() {
				this.noteVideo_play && this.$refs.note_video.pause();
				this.recoveryVideo_play && this.$refs.recovery_video.pause();
			}
		},
		watch: {
			scrollTop(newVal) {
				if (newVal >= this.noteVideo_offsetTop && this.noteVideo_play) {
					this.$refs.note_video.pause();
				}
				if (newVal >= this.recoveryVideo_offsetTop && this.recoveryVideo_play) {
					this.$refs.recovery_video.pause();
				}
			}
		}
	}
</script>

<style scoped>
	.pro_step{ position: relative;width: 1200px;margin: 40px auto 0;padding: 68px 184px 98px 116px;border-radius: 10px;background: #fff;overflow: hidden; }
	.pro_step .step{ position: relative;padding: 0 0 60px 90px; }
	.pro_step .step:last-child{ padding-bottom: 0; }
	.pro_step .step::before{ content: "";display: block;position: absolute;width: 1px;height: 100%;top: 0;left: 23.5px;border-left: 1px dashed #2b53c6; }
	.pro_step .step .num{ display: block;position: absolute;width: 48px;height: 48px;top: 0;left: 0;border-radius: 50%;font-size: 26px;color: #fff;text-align: center;line-height: 48px; }
	.pro_step .install_l{ float: left; }
	.pro_step .install_l .detail{ margin-top: 10px;font-size: 18px;line-height: 36px; }
	.pro_step .install_r{ float: right;width: 350px;height: 130px;margin-top: 6px;padding: 20px 20px 0;background-image: url(../../../../assets/download_theme_bg.png);background-size: 100% 100%; }
	.pro_step .install_r .title{ font-size: 20px;color: #fff;text-align: center;line-height: 36px; }
	.pro_step .install_r .ways{ margin-top: 20px;font-size: 18px;text-align: center;line-height: 30px; }
	.pro_step .install_r .way{ color: #ffc000; }
	.pro_step .install_r .pc_icon{ display: inline-block;width: 23px;height: 21px;margin: 4.5px 10px 0 0;background-image: url(../../../../assets/pc_yellow.png);vertical-align: top; }
	.pro_step .install_r .download_icon{ display: inline-block;width: 21px;height: 19px;margin: 5.5px 10px 0 0;background-image: url(../../../../assets/download_yellow.png);vertical-align: top; }
	
	.pro_step .video_box{ position: relative;height: 375px;margin-top: 15px;border-radius: 5px;overflow: hidden; }
	.pro_step .video_box img{ display: block;position: absolute;top: 50%;left: 50%;max-width: 100%;transform: translate(-50%, -50%); }
	.pro_step .video_box video{ display: block;width: 100%;height: 100%; }
	.pro_step .video_box .mask{ position: absolute;width: 100%;height: 100%;top: 0;left: 0;background: rgba(0, 0, 0, 0.7);cursor: pointer; }
	.pro_step .video_box .mask i{ display: block;position: absolute;width: 60px;height: 60px;top: 50%;left: 50%;margin: -30px 0 0 -30px;background-image: url(../../../../assets/video_play.png);background-size: 100% 100%; }
	
	.pro_step .video_group .title{ font-size: 24px;font-weight: bold;line-height: 56px; }
	.pro_step .video_group .title i{ display: inline-block;width: 6px;height: 22px;margin: 17px 8px 0 0;vertical-align: top; }
	.pro_step .video_item{ float: left;width: 262px;margin: 0 12px 10px 0; }
	.pro_step .video_item:nth-child(3n){ margin-right: 0; }
	.pro_step .video_wrap{ position: relative;height: 148px;border-radius: 5px;overflow: hidden; }
	.pro_step .video_wrap .mask{ position: absolute;width: 100%;height: 100%;top: 0;left: 0;background: rgba(0, 0, 0, 0.7);cursor: pointer; }
	.pro_step .video_wrap .mask i{ display: block;position: absolute;width: 26px;height: 26px;top: 50%;left: 50%;margin: -13px 0 0 -13px;background-image: url(../../../../assets/video_play.png);background-size: 100% 100%; }
	.pro_step .video_name{ font-size: 18px;color: #333;text-align: center;line-height: 36px; }
	
	.pro_step .reveal_l{ float: left;width: 288px;height: 571px; }
	.pro_step .reveal_l img{ display: block;width: 100%;height: 571px; }
	.pro_step .reveal_r{ float: right;width: 488px;height: 356px; }
	.pro_step .reveal_r .cui{ display: block;width: 100%;height: 356px; }
	.pro_step .code_desc{ margin: 48px auto 0;font-size: 16px;color: #364b60;line-height: 20px; }
	
	.pro_step .step .step_title{ font-size: 30px;font-weight: bold;line-height: 48px; }
	.pro_step .step .step_name{ font-size: 18px;line-height: 48px; }
	.pro_step .speed_logo{ display: inline-block;width: 34px;height: 34px;margin: 7px 0 0 15px;background-image: url(../../../../assets/360.png);background-size: 100% 100%;vertical-align: top; }
	.pro_step .chrome_logo{ display: inline-block;width: 34px;height: 34px;margin: 7px 0 0 15px;background-image: url(../../../../assets/chrome.png);background-size: 100% 100%;vertical-align: top; }
</style>
